import { ambienteInternoPontoForteService } from "./AmbienteInternoPontoForteService";
import { ambienteInternoPontoFracoService } from "./AmbienteInternoPontoFracoService";
import { ambienteExternoService } from "./AmbienteExternoService";
import { AMEACA_NORMALIZADO, OPORTUNIDADE_NORMALIZADO } from "../types/constants/ClassificacaoAmbienteExterno";
import { normalize } from "../utils/string";
import { AmbienteExterno } from "../types/negocio/AmbienteExterno";
import { AmbienteInternoPontoForte } from "../types/negocio/AmbienteInternoPontoForte";
import { AmbienteInternoPontoFraco } from "../types/negocio/AmbienteInternoPontoFraco";

export interface SwotData {
    pontosFortesPontuacaoTotal: number;
    pontosFracosPontuacaoTotal: number;
    oportunidadesPontuacaoTotal: number;
    ameacasPontuacaoTotal: number;
}

export const swotAnalysisService = {
    /**
     * Obtém os dados da análise SWOT com a pontuação total de cada categoria
     */
    obterDadosSwot: async (): Promise<SwotData> => {
        try {
            const promises = [];
            let pontosFortes: AmbienteInternoPontoForte[] = [];
            let pontosFracos: AmbienteInternoPontoFraco[] = [];
            let oportunidades: AmbienteExterno[] = [];
            let ameacas: AmbienteExterno[] = [];

            promises.push(ambienteInternoPontoForteService.listarTodos().then((response) => pontosFortes = response));
            promises.push(ambienteInternoPontoFracoService.listarTodos().then((response) => pontosFracos = response));
            promises.push(ambienteExternoService.listarTodos().then((response) => {
                oportunidades = response.filter((item) => normalize(item.fator) === OPORTUNIDADE_NORMALIZADO);
                ameacas = response.filter((item) => normalize(item.fator) === AMEACA_NORMALIZADO);
            }));

            await Promise.all(promises);

            const pontosFortesPontuacaoTotal = pontosFortes.reduce((acc, e) => acc + e.pontuacao, 0);
            const pontosFracosPontuacaoTotal = pontosFracos.reduce((acc, e) => acc + e.pontuacao, 0);
            const oportunidadesPontuacaoTotal = oportunidades.reduce((acc, e) => acc + e.pontuacao, 0);
            const ameacasPontuacaoTotal = ameacas.reduce((acc, e) => acc + e.pontuacao, 0);

            return {
                pontosFortesPontuacaoTotal,
                pontosFracosPontuacaoTotal,
                oportunidadesPontuacaoTotal,
                ameacasPontuacaoTotal
            };
        } catch (error) {
            console.error("Erro ao obter dados da análise SWOT:", error);
            throw error;
        }
    }
};
